import React, { PureComponent, Fragment } from 'react';
import { Col, Container, Row,  Card, CardBody, Button } from 'reactstrap';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { setUserProfile } from '../../redux/actions/authActions';

import Exports from './components/Exports';

import BuyerAgentIcon from 'mdi-react/AccountOutlineIcon';
import SalesGalleryIcon from 'mdi-react/FloorPlanIcon';
import MediaIcon from 'mdi-react/BullhornOutlineIcon';
import EnterpriseIcon from 'mdi-react/DomainIcon';

import showResults from './Show';

import SnackBar from '../../shared/components/SimpleSnackBar';

import TrialAlert from '../../shared/components/payment/TrialAlert';

import EmptyExportList from './components/EmptyExportList';


import fileDownload from 'js-file-download';
import QuickStartGuide from '../../shared/components/QuickStartGuide';


import{
	_capitalizeText,
} from '../../shared/helpers/utils';
import{
	_axiosCall
} from '../../shared/helpers/apicalls';
const oktaToken = process.env.OKTA_TOKEN;

const apiUrl = process.env.API_ROOT;
//const apiUrl = 'http://localhost:8000/buyerslist/';

//const apiUrl = 'https://newsapi.we3.com/buyerslist/'

class Profile extends PureComponent {
	constructor(props) {
	    super(props);
	    this.state = {
		  fetchInProgress: false,
		  snackShow: false,
		  snackMessage: false,
		  snackType: 'success',
		  exports: null,
		  refresh: false,
		  page: 1,
		  limit: 20,
		  total: 0
		};
	    this.snackOpen = this.snackOpen.bind(this);
	    this.snackClose = this.snackClose.bind(this);
	    this._getExportDetails = this._getExportDetails.bind(this);
	    this.toggleRefresh = this.toggleRefresh.bind(this);
	    this._getDownload = this._getDownload.bind(this);
	    
	}
	  
    componentDidMount(){
	  const { authState, authService, dispatch, user } = this.props;
	  console.log(authState);
	  this._getExportDetails();
    }
    componentDidUpdate(prevProps, prevState) {
	    
	    const { user } = this.props;
	    
	    if(prevState.refresh !== this.state.refresh){
		     this._getExportDetails();

	    }
	    
	}
   	
	toggleRefresh = () => {
    	this.setState(prevState => ({ refresh: !prevState.refresh }));;
    };
	
	snackOpen = (message, type) => {
    	this.setState( { snackShow: true, snackMessage: message, snackType : type} )
    };

    snackClose = (event, reason) => {
	    if (reason === 'clickaway') {
	      return;
	    }	
	    this.setState( { snackShow: false, snackMessage: ''} )
	};
	
	_getExportDetails = () => {
	  const { user } = this.props;
	  const { page, limit } = this.state;
	  const { subscriptionId } = user;
	  if (!subscriptionId) return false;
	
	  let userData = {
		url: apiUrl + '/dataexport/my-exports',
		method: "post",
		query: {
		  query : {user_key: user.id},
		  page,
		  limit
		},
		
	  };
	
	  _axiosCall(userData)
		.then(res => {
		  if (res && res.results && res.results.length >= 0) {
			this.setState({
			  exports: res.results,
			  total: res.total || 0
			});
		  } else {
			this.setState({ exports: [], total: 0 });
		  }
		})
		.catch((error) => {
		  console.log("_getExportDetails error ", error);
		});
	};
	
	_getDownload = (download_id, filename) => {
     // console.log('_getBuildingData called', this.state)
           
      const { authState, authService, dispatch, user } = this.props;      
      const { subscriptionId } = user;
	  
	  if(!subscriptionId) return false;
	  	  
 	
	  let userData = {
			url: apiUrl+'/dataexport/get-download',
			method: "post",
			query: {
				download_id: download_id
			}
	  };
	  
	  
	  _axiosCall(userData)
	    .then(res => {      
	      fileDownload(res, filename);    	      
	  })
	  .catch((error) => {
	    console.log("_getExportDetails error ", error);
	  });

	}
	
	render(){
		const { snackShow, snackMessage, snackType, exports } = this.state;
		const { user } = this.props;
		if(exports === null) return null;
		return (
			<Container>
				<SnackBar 
					snackShow={snackShow} 
					snackMessage={snackMessage} 
					snackClose={this.snackClose} 
					snackDuration={5000} 
					snackType={snackType} 
				/>
			    <Row>
			      <Col md={12}>
			        <h3 className="page-title">{`My Downloads`}</h3>
			        <h3 className="page-subhead subhead">Access Your Data Exports and Owner Lists.</h3>
			      </Col>
			    </Row>
				<QuickStartGuide link={"https://help.marketproof.com/en/articles/10553241-downloads"} type={"Downloads"} />

			    <Row>
			      <Col md={12} className={'mb-3'}>
			       	<TrialAlert />        
			      </Col>
			    </Row>
				<Fragment>    			    
				    {exports && exports.length > 0 ?
					    <Row>
					      <Exports {...this.props} total={this.state.total} exports={exports} getDownload={this._getDownload} />		
						  {exports && exports.length > 0 && (
							<Col md={12} lg={12}>
							<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '30px', width:"100%" }}>
							  <Button
								disabled={this.state.page <= 1}
								onClick={() => this.setState(prev => ({ page: prev.page - 1 }), this._getExportDetails)}
							  >
								Prev
							  </Button>
							  <div style={{ paddingTop: '7px' }}>
								Page {this.state.page} of {Math.ceil(this.state.total / this.state.limit)} ({this.state.total} exports)
							  </div>
							  <Button
								disabled={this.state.page >= Math.ceil(this.state.total / this.state.limit)}
								onClick={() => this.setState(prev => ({ page: prev.page + 1 }), this._getExportDetails)}
							  >
								Next
							  </Button>
							</div>
							</Col>
						  )}	      
					    </Row>
					    :
					    <Row>
					      <EmptyExportList {...this.props}/>			      
					    </Row>
					    
				    }
			    </Fragment>
				    
			    

			</Container>
		);	
	}
  
};

export default connect(state => ({
  user: state.user,
}))(withOktaAuth(Profile));
